export const LOAD_ALL_CONVERSIONS_DATA = "LOAD_ALL_CONVERSIONS_DATA";
export const LOAD_CONVERSIONS_DATA_SUCCESS = "LOAD_ALL_CONVERSIONS_DATA_SUCCESS";
export const LOAD_CONVERSIONS_DATA_FAILED = "LOAD_ALL_CONVERSIONS_DATA_FAILED";
export const LOAD_INIT_STATE = "LOAD_INIT_STATE";

export const LOAD_LAST_ROWS = "LOAD_LAST_ROWS";
export const SEARCHED_VALUE = "SEARCHED_VALUE";

